import { render, staticRenderFns } from "./fakulteyonetimkurulu.vue?vue&type=template&id=a55498c0&"
import script from "./fakulteyonetimkurulu.vue?vue&type=script&lang=js&"
export * from "./fakulteyonetimkurulu.vue?vue&type=script&lang=js&"
import style0 from "./fakulteyonetimkurulu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports